import React from "react";

import styled from "styled-components";
import Joyride from "react-joyride-react-19";
import { BloxButton } from "styled_components/Common/BloxButton";
import { JoyRideToolTip } from "styled_components/Common/JoyRideToolTip";
const TourStyle = styled.div`
  @media screen and (min-width: ${(props) =>
      props.theme.res.medium}) and (max-width: ${(props) =>
      props.theme.res.high}) {
  }
  @media screen and (min-width: ${(props) => props.theme.res.high}) {
  }
`;

export const IssueRequestTour = ({
  id,
  cypressId,
  handleTourCallback,
  tourSelected,
  setStepIndex,
  stepIndex,
}) => {
  const steps = [
    {
      title: "Support Overview",
      content:
        "The support area is the home of support tickets, remote hands and guest access requests.",
      placement: "center",
      locale: { skip: "S-K-I-P" },
      target: ".header-section",
      module: "support",
    },
    {
      target: "#special-id-2",
      module: "support",
      noBackButton: true,
      content: "You will click here to start a support ticket.",
      customNextButton: (
        <BloxButton
          className="buttons41"
          id="continue-tour"
          text="Next"
          module="support"
          enabled={true}
          onClick={() => {
            document.getElementById("special-id-2").click();
            setTimeout(() => setStepIndex(stepIndex + 1), 500);
          }}
          cypressId="continue-tour"
        />
      ),
    },
    {
      target: ".issue-request-wizard",
      content:
        "Here you will be able to select what type of support ticket you need by clicking on the images.",
      module: "support",
      noBackButton: true,
      customNextButton: (
        <BloxButton
          className="buttons41"
          id="continue-tour"
          text="Next"
          module="support"
          enabled={true}
          onClick={() => {
            document.getElementById("type-selection-support").click();
            setTimeout(() => setStepIndex(stepIndex + 1), 1000);
          }}
          cypressId="continue-tour"
        />
      ),
    },
    {
      target: ".issue-request-wizard",
      content:
        "Let us know what service you are having an issue with by clicking on that image.",
      module: "support",
      noBackButton: true,
      customNextButton: (
        <BloxButton
          className="buttons41"
          id="continue-tour"
          text="Next"
          module="support"
          enabled={true}
          onClick={() => {
            document.getElementById("portal").click();
            setTimeout(() => setStepIndex(stepIndex + 1), 1000);
          }}
          cypressId="continue-tour"
        />
      ),
    },

    {
      target: ".issue-request-wizard",
      content: "Next , you can select the priority of your request.",
      module: "support",
      noBackButton: true,
      customNextButton: (
        <BloxButton
          className="buttons41"
          id="continue-tour"
          text="Next"
          module="support"
          enabled={true}
          onClick={() => {
            console.log("priority", document.getElementById("priority-low"));
            document.getElementById("priority-low").click();
            setTimeout(() => setStepIndex(stepIndex + 1), 1500);
          }}
          cypressId="continue-tour"
        />
      ),
    },
    {
      target: ".issue-description-section",
      content: "The details of your support request can be added here.",
      module: "support",
      noBackButton: true,
      customNextButton: (
        <BloxButton
          className="buttons41"
          id="continue-tour"
          text="Next"
          module="support"
          enabled={true}
          onClick={() => {
            setTimeout(() => setStepIndex(stepIndex + 1), 1000);
          }}
          cypressId="continue-tour"
        />
      ),
    },

    {
      target: ".upload-section",
      content:
        "Here, you can add any attachments or files relating to your request.",
      module: "support",
      noBackButton: true,
      customNextButton: (
        <BloxButton
          className="buttons41"
          id="continue-tour"
          text="Next"
          module="support"
          enabled={true}
          onClick={() => {
            document.getElementById("next-issue-description").click();
            setTimeout(() => setStepIndex(stepIndex + 1), 1000);
          }}
          cypressId="continue-tour"
        />
      ),
    },
    {
      target: ".issue-request-wizard",
      content:
        "Let us know the best way to contact you about your request by clicking on the images shown.",
      module: "support",
      noBackButton: true,
      customNextButton: (
        <BloxButton
          className="buttons41"
          id="continue-tour"
          text="Next"
          module="support"
          enabled={true}
          onClick={() => {
            document.getElementById("contact-selection-email").click();
            setTimeout(() => setStepIndex(stepIndex + 1), 1000);
          }}
          cypressId="continue-tour"
        />
      ),
    },
    {
      target: ".issue-request-wizard",
      content:
        "You can select or add a new email / phone number for us to contact you on.",
      module: "support",
      noBackButton: true,
      customNextButton: (
        <BloxButton
          className="buttons41"
          id="continue-tour"
          text="Next"
          module="support"
          enabled={true}
          onClick={() => {
            document.getElementById("preference-0").click();
            setTimeout(() => setStepIndex(stepIndex + 1), 1000);
          }}
          cypressId="continue-tour"
        />
      ),
    },
    {
      target: ".issue-request-wizard",
      content: "Use the next button to get to the final step.",
      module: "support",
      noBackButton: true,
      customNextButton: (
        <BloxButton
          className="buttons41"
          id="continue-tour"
          text="Next"
          module="support"
          enabled={true}
          onClick={() => {
            document.getElementById("formButton").click();
            setTimeout(() => setStepIndex(stepIndex + 1), 1000);
          }}
          cypressId="continue-tour"
        />
      ),
    },
    {
      target: ".issue-request-wizard",
      content:
        "The final step is to review your request and make any edits before submitting.",
      module: "support",
      noBackButton: true,
      locale: { next: "Finish" },
    },
  ];
  return (
    <TourStyle id={id} cypressId={cypressId}>
      <Joyride
        stepIndex={stepIndex}
        steps={steps}
        continuous={true}
        showProgress
        showSkipButton
        styles={{
          options: {
            zIndex: 5000,
          },
        }}
        tooltipComponent={JoyRideToolTip}
        run={tourSelected === "issue-request" ? true : false}
        disableScrolling={true}
        callback={handleTourCallback}
        disableOverlayClose={true}
      />
    </TourStyle>
  );
};
